// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2405":"25e9ec3e","5480":"25e9ec3e","7815":"25e9ec3e"}[chunkId] + ".chunk.css";
};